import { Link } from "react-router-dom";
import "./NotableUserTerms.css";

const NotableUserTerms = () => {
  return (
    <>
      <div className="container Notable-Terms-Page">
        <div className="justify-content-center align-items-center">
          <div className="font-500-44 mt-2 Termstitle">
            Notable User Terms of Service 
          </div>
          <div className="d-block justify-content-center pt-2">
            <p className="font-300-15">
              Please read these Notable User Terms of Service (this{" "}
              <span className="spanterms">“Agreement”</span>) carefully. By
              clicking “accept” to this Agreement, or by accessing or using the
              Service (as defined below), you consent to be bound by this
              Agreement. <br></br>
            </p>
            <p className="font-300-15">
              This Agreement is between you, as a{" "}
              <span className="spanterms">Notable User</span> (defined below)
              and Fan1 LLC{" "}
              <span className="spanterms">(“Company,” “us” “our” or “we”)</span>{" "}
              concerning your use of our website and mobile applications (the
              <span className="spanterms">“Site”</span>) and the services and
              products we provide through our Site, including our open
              marketplace where users can participate in an auction or purchase
              an exclusive membership to be your “Fan1” for a defined membership
              period (the <span className="spanterms">“Marketplace”</span>). The
              Site, Marketplace, and all products and services provided by us
              are collectively referred to as the{" "}
              <span className="spanterms">“Service.”</span>
            </p>
            <p className="font-300-15">
              This Agreement applies solely to actors, athletes, artists,
              influencers, and other recognized personalities (each, a “
              <span className="spanterms">Notable Person</span>” ) and other
              fictional persons or characters, places, things, businesses,
              movies, items, or concepts (each, an “
              <span className="spanterms">Other Figure</span>”) that use the
              Marketplace to offer a Fan1 membership to our users. A Notable
              Person or Other Figure are collectively referred to as a “
              <span className="spanterms">Notable User</span>.”
            </p>
            <p className="font-300-15">
              By clicking “accept” to this Agreement or accessing or using the
              Service, you affirm that you are a Notable User and have the legal
              capacity to enter into this Agreement. This Agreement hereby
              incorporates by this reference any additional terms and conditions
              posted by the Company on the Site to which you agree.
            </p>
            <span className="spanterms">
              Notice of Waiver: This Agreement contains a mandatory arbitration
              of disputes provision that requires the use of arbitration on an
              individual basis to resolve disputes, rather than jury trials or
              class actions, subject to your right to opt-out as set forth in
              Section 17 below.
            </span>
            <p>
              <span className="spanterms">1. Changes to this Agreement</span>
              <p className="font-300-15">
                We may change this Agreement by notifying you of such changes by
                any reasonable means, including by posting a revised Agreement
                on the Site, and/or by sending to you a notice of the revised
                Agreement by email or as a Site notification. Any changes to
                this Agreement will not apply to any dispute between you and us
                arising prior to the date on which we posted the revised
                Agreement incorporating such changes, or otherwise notified you
                of such changes. Your clicking “accept” to this Agreement or
                your access to or use of the Service following any changes to
                this Agreement will constitute your acceptance of such changes.
                The “Last Modified” date below indicates when this Agreement was
                last changed. We may, at any time and without liability, modify
                or discontinue all or part of the Service (including access to
                the Service via any third-party links); charge, modify, or waive
                any fees required to use the Service; or offer opportunities to
                some or all Service users. We reserve the right to introduce new
                features or functionality for which the payment of fees may be
                required.
              </p>
            </p>

            <p>
              <span className="spanterms">
                2. Memberships and the Marketplace
              </span>
              <ol>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">Fan1 Memberships.</span>
                  The Marketplace allows you the opportunity to offer a singular
                  and exclusive membership either through an auction or at a
                  fixed price. For any type of membership, the highest bidder in
                  an auction with a successful payment, or the first to purchase
                  at a fixed price, secures the membership and becomes your sole
                  “Fan1” for a predefined membership period. During the
                  membership period, the Fan1 will have those benefits outlined
                  in the Marketplace, such as direct communication with you, or,
                  as applicable, an Administrator (defined below), and the
                  exclusive right to post on your public page on the Site. The
                  benefits associated with being the Fan1 may vary according to
                  the terms set forth on the Site for each applicable
                  membership.
                </li>
                <li className="font-300-15 mt-2">
                  <span className="spanterms"> Marketplace Use</span>. Your use
                  of the Marketplace is governed by the features and functions
                  of the Site, which may be continually updated. In all cases,
                  your use of the Service is subject to your adherence to our
                  Code of Conduct. You agree to follow the Code of Conduct in
                  all aspects of your use of the Service. Participation in any
                  specific features of the Site, such as setting the rules of
                  any membership offer, commenting on any message board, or
                  accessing information may be subject to additional rules and
                  restrictions.
                </li>
              </ol>
            </p>

            <p>
              <span className="spanterms">3. Eligibility and Registration</span>
              <ol>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">Registration</span>. In order to
                  participate as a Notable User, you must sign up for a user
                  account on our Site and register by completing the
                  registration form provided. You and/or your authorized agent
                  agree to provide accurate, current, and complete information
                  as requested by our registration form, in addition to any
                  other information we reasonably request (the “Registration
                  Data”). Upon registration, we will determine in our sole
                  discretion if you meet the criteria as a Notable User. If so,
                  your user account will be upgraded to a Notable User account
                  on our Site. You agree (a) that the{" "}
                  <span className="spanterms">Registration Data</span> you
                  provide to us will be true, accurate, current, and complete at
                  the time you provide it and (b) to maintain and update your
                  Registration Data to keep it true, accurate, current and
                  complete. If you are acting as an authorized agent of the
                  Notable Person or Administrator (defined below) you further
                  represent that you have all rights and authority to register
                  on behalf of the Notable User and agree to indemnify and hold
                  the Company harmless if you do not have such proper right and
                  authority. We may reject or require that you change any
                  username, password, profile photo, or other information that
                  you provide to us in registering for any valid reason. Your
                  email, password, and other login credentials are for your
                  personal use only and should be kept confidential. You are
                  solely responsible for any use or misuse of your login
                  credentials and you must promptly notify us of any actual or
                  suspected confidentiality breach or unauthorized use of your
                  login credentials.
                </li>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">18 and Older</span>. Notable Users
                  who are 18 years of age and older may register directly. By
                  registering, you represent and warrant that: (a) you are at
                  least 18 years old; (b) you are of legal age to form a binding
                  agreement; (c) you are not barred from using our Service under
                  US law or any other applicable jurisdiction; and (d) you are
                  responsible for complying with all applicable laws and
                  regulations relating to your use of our Service and agree to
                  fully indemnify us and any Fan1 for any failure to do so.
                </li>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">Parent or Legal Guardian</span>
                  . Notable Users who are under 18 years of age may only
                  register through a parent or legal guardian who, by
                  registering, represents and warrants that: (a) they are the
                  parent or legal guardian of the Notable User, with full rights
                  to enter into this Agreement on behalf of the Notable User;
                  (b) neither you nor the Notable User is barred from using our
                  Service under US law or any other applicable jurisdiction; and
                  (c) you are responsible for complying with all applicable laws
                  and regulations relating to the Notable User’s use of our
                  Service and will fully indemnify Fan1 for any failure to do
                  so. The parent or guardian of any Notable User is fully
                  responsible and liable under this Agreement as the Notable
                  User.
                  <br />
                  Ownership. Excluding User Content (defined below), you
                  acknowledge that all the material and content available on or
                  through the Service, including all intellectual property
                  rights, such as copyrights, patents, trademarks, and trade
                  secrets, in such material or content are owned by Company (or
                  Company’s licensors), including all graphics, code, copy,
                  music, videos, images, data, and the look and feel of the
                  Service. The provision of the Service does not transfer to you
                  or any third party any rights, title, or interest in or to
                  such rights. Company (or its licensors) reserve all rights not
                  granted in this Agreement.
                </li>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">
                    Administrator of Other Figure
                  </span>
                  . An owner, manager, company or other individual or
                  organization that lawfully owns or licenses the rights to an
                  Other Figure (each, an “
                  <span className="spanterms">Administrator</span>”) may
                  register such Other Figure as a Notable User. By registering,
                  the Administrator represents and warrants that: (a)
                  Administrator is the authorized representative of its Other
                  Figure with all rights to act and enter into this Agreement as
                  the Other Figure; (b) neither the Administrator or its
                  affiliated Other Figure is barred from using our Service under
                  US law or any other applicable jurisdiction; and (c)
                  Administrator is responsible for complying with all applicable
                  laws and regulations relating to its affiliated Other Figure’s
                  use of our Service and will fully indemnify Fan1 for any
                  failure to do so. In no event may you register as an Other
                  Figure if such Other Figure is in the public domain or a
                  place, concept, or thing to which no person holds or could
                  hold exclusive rights therein to claim to be the Administrator
                  (e.g. the City of Seattle).
                </li>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">
                    Collegiate or Amateur Athletes
                  </span>
                  . If you are or may become subject to the rules and
                  regulations promulgated by the National College Athletic
                  Association (“NCAA”) or other amateur organizations, you
                  verify and confirm that your use of our Service does not or
                  will not affect your current or future eligibility with
                  respect to any such group, association, or organization.
                </li>
              </ol>
            </p>

            <p>
              <span className="spanterms">4. Account Responsibilities</span>
              <p className="font-300-15">
                Only you may access or use the Service through any account you
                create on the Site. You are responsible for all activities that
                occur under your account. You agree to immediately notify us of
                any unauthorized use, or suspected unauthorized use, of the
                account or any other breach or suspected breach of security. We
                are not liable for any loss or damage arising from any
                unauthorized use of your account or the failure to comply with
                the above requirements.
              </p>
            </p>
            <p>
              <span className="spanterms">5. Right to Use the Service</span>
              <ol>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">Use Right</span>. Subject to the
                  terms of this Agreement, Company grants you a
                  non-transferable, non-exclusive, non-sublicensable, revocable
                  right to access and use the Service solely for its intended
                  purpose as permitted by the features and functions of the
                  Site. Upon termination of this Agreement, your right to use
                  the applicable portion of, or the entire Service, will
                  terminate immediately.
                </li>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">Certain Restrictions</span>. The
                  rights granted to you in this Agreement are subject to the
                  following restrictions: (a) you may not license, sell, rent,
                  lease, transfer, assign, distribute, or otherwise commercially
                  exploit the Service (other than for its purpose); (b) you may
                  not modify, make derivative works of, disassemble, reverse
                  compile, or reverse engineer any part of the Service; (c) you
                  may not access the Service in order to build a similar or
                  competitive service; and (d) except as expressly stated on or
                  enabled by the Service, no part of the Service may be copied,
                  reproduced, distributed, republished, downloaded, displayed,
                  posted, or transmitted in any form or by any means. Any future
                  release, update, or other addition to functionality of the
                  Service will be subject to the terms of this Agreement. All
                  copyright and other proprietary notices on the Service must be
                  retained on all copies thereof.
                </li>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">
                    Modification, Suspension, or Discontinuance
                  </span>
                  . The Company may, from time to time in its sole discretion,
                  modify or discontinue the Service or any part thereof, change
                  features or functions, develop updates, upgrades, or other
                  modifications, with or without notice. To the extent you are
                  in compliance with this Agreement, prior to any change that
                  might discontinue a material portion of the Service and
                  adversely limit the type or scope of functionality available
                  to you, we will make reasonable efforts to provide you with
                  notice of such discontinuance. Notwithstanding the foregoing,
                  you agree that we will not be liable for any modification or
                  suspension of the Service or any part thereof.
                </li>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">Ownership</span>. Excluding
                  Notable User Content (defined below), you acknowledge that all
                  the material and content available on or through the Service,
                  including all intellectual property rights, such as
                  copyrights, patents, trademarks, and trade secrets, in such
                  material or content are owned by Company (or Company’s
                  licensors), including all graphics, code, copy, music, videos,
                  images, data, and the look and feel of the Service. The
                  provision of the Service does not transfer to you or any third
                  party any rights, title, or interest in or to such rights.
                  Company (or its licensors) reserve all rights not granted in
                  this Agreement.
                </li>
              </ol>
            </p>

            <p>
              <span className="spanterms">
                6. Links, Advertisements, other Third-Party Materials
              </span>
              <p className="font-300-15">
                The Service may make third-party material available to you,
                including advertisements and marketing material delivered to you
                as part of the Service (“
                <span className="spanterms">Third-Party Materials</span>”), or
                allow for the routing or transmission of such Third-Party
                Materials, including via links. By using such functionality, you
                are directing us to access, route, and transmit to you the
                applicable Third-Party Materials. We neither control nor
                endorse, nor are we responsible for, any Third-Party Materials,
                including the accuracy, integrity, quality, legality,
                usefulness, or safety of Third-Party Materials, or the nature of
                any intellectual property rights therein. Certain Third-Party
                Materials may, among other things, be inaccurate, misleading, or
                deceptive. Nothing in this Agreement will be deemed to be a
                representation or warranty by Company with respect to any
                Third-Party Materials. We have no obligation to monitor
                Third-Party Materials, and we may block or disable access to any
                Third-Party Materials (in whole or part) through the Service at
                any time. In addition, the availability of any Third-Party
                Materials through the Service does not imply our endorsement of,
                or our affiliation with, any provider of such Third-Party
                Materials, nor does such availability create any legal
                relationship between you and any such provider. You acknowledge
                sole responsibility for and assume all risk arising from your
                use of any Third-Party Materials.
              </p>
            </p>

            <p>
              <span className="spanterms">7. Membership Payments</span>
              <ol>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">Fan1 Payout</span>. Other than for
                  fixed price memberships, you permit the Marketplace to set the
                  auction terms for each of your Fan1 memberships. You are
                  prohibited from attempting to manipulate or alter any Fan1
                  membership auction, including by submitting fake bids or other
                  bids that are not a bona fide bid to win the Fan1 membership,
                  or soliciting others to do the same. Subject to this Agreement
                  and absent a separate agreement with you, Company will pay you
                  the percentage of the payment received for the sale of your
                  Fan1 membership, either through a fixed price or bidding
                  auction, as such percentage is set forth on the Marketplace
                  when you complete the registration process for offering the
                  Fan1 membership (the “
                  <span className="spanterms">Fan1 Payout</span>
                  ”). The Fan1 Payout excludes sales taxes and any service,
                  transaction, or processing fee paid to Company. At our
                  discretion, we may reserve payment of up to 50% of the Fan1
                  Payout until the end date of any applicable membership period
                  to ensure your compliance with the terms of the Fan1
                  membership. Failure to comply will result in the cancellation
                  of any further amounts of the Fan1 Payout being owed to you
                  and we may require repayment of any portion of the Fan1 Payout
                  paid to you. Additionally, if we are required to or choose to
                  offer a refund to the purchaser of your Fan1 membership due to
                  your breach of the Fan1 membership requirements (e.g. failure
                  to engage on the Site or abide by other promises made to your
                  Fan1), you will be liable for repayment of the amount of the
                  Fan1 Payout, in whole or in part.
                </li>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">Payment Provider</span>. You agree
                  to register with the third-party payment provider selected by
                  Company, which we may change in our sole discretion. In order
                  to receive payments, you must provide the third-party payment
                  provider any requested information. We will not be responsible
                  for any damages, losses, costs, expenses, or damages arising
                  out of or in connection with your inability to receive
                  payments due to your failure to provide such information.
                  Because we do not own, operate, or control the third-party
                  payment provider, you agree that your use of any payment
                  provider is subject to the terms and privacy policies of that
                  third-party payment provider. You agree that Company is not
                  responsible for any delay, damage, failure, or liability
                  caused by a third-party payment provider, any other third
                  party, a force majeure event, or your failure to timely or
                  properly set up an account with the third-party payment
                  provider.
                </li>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">Currency</span>. Payments via the
                  third-party payment provider are in U.S. dollars unless the
                  third-party payment provider permits you to choose another
                  currency.
                </li>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">Charitable Donations</span>. Your
                  account includes an option for designating a percentage of the
                  Fan1 Payout for donation to a charitable organization of your
                  choice. The percentage of the Fan1 Payout designated for
                  donation will be determined based on the setting you have
                  selected in your account at the of the Fan1 membership
                  purchase. We will process and distribute charitable
                  contributions automatically in your name, unless the
                  designated charity does not accept contributions made in the
                  name of another individual. By enabling this option, you
                  acknowledge and agree that charitable contributions made on
                  your behalf are final and non-refundable. We do not guarantee
                  the tax-deductibility of such donations, and it is your
                  responsibility to consult with a tax professional regarding
                  any potential implications. Company is not affiliated with and
                  does not endorse any specific charity and is not a commercial
                  co-venturer with respect to your arrangements with your
                  designated charity (unless otherwise expressly stated in
                  writing by Company). We do not make any warranties about your
                  designated charity or any donation to that charity.
                </li>
              </ol>
            </p>

            <p>
              <span className="spanterms">8. Feedback</span>
              <p className="font-300-15">
                We welcome any ideas, proposals, suggestions for improvements to
                the Service or other materials (“Feedback”). You can submit
                Feedback by emailing us at the contact email listed below,
                submitting contact forms, or speaking directly to an authorized
                agent of Company. You grant to us a non-exclusive, worldwide,
                perpetual, irrevocable, fully-paid, royalty-free, sublicensable,
                and transferable license under any and all intellectual property
                rights that you own or control to use, copy, modify, create
                derivative works based upon, and otherwise exploit the Feedback
                for any purpose. You hereby acknowledge and agree that such
                Feedback is not confidential, and that your provision of such
                Feedback is gratuitous, unsolicited and without restriction, and
                does not place Company under any fiduciary or other obligation.
                You hereby assign to Company all rights in the Feedback and
                agree that Company will have the right to use such Feedback and
                related information in any manner it deems appropriate. Company
                will treat any Feedback as non-confidential and non-proprietary.
                You agree not to submit as Feedback any information or ideas
                that you consider to be confidential or proprietary.
              </p>
            </p>

            <p>
              <span className="spanterms">9. Notable User Content</span>
              <ol>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">Notable User Content</span>.
                  “Notable User Content” includes any and all information and
                  content that a Notable User, including you, may submit to the
                  Service, including profile information and messages or other
                  content you post or submit to or through any message board or
                  other feature of the Site. You are solely responsible for all
                  of your Notable User Content. You assume all risks associated
                  with the use of your own and other user’s content, including
                  any reliance on its accuracy, completeness, or usefulness by
                  others, or any disclosure of such that makes it or any third
                  party personally identifiable or improperly uses third party
                  proprietary or intellectual property rights.
                </li>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">
                    Company License to Notable User Content
                  </span>
                  . Notwithstanding anything herein to the contrary and as
                  applicable, you hereby grant, and represent that you have the
                  right to grant, to Company an irrevocable, non-exclusive,
                  royalty-free and fully-paid, worldwide license to reproduce,
                  distribute, modify, publicly display, perform, prepare
                  derivative works of, incorporate into other works, and
                  otherwise use your Notable User Content, and to grant
                  sublicenses of the foregoing, for purposes of providing the
                  Service, creating and using aggregated, de-identified data for
                  the purpose of improving upon the functionality of the
                  Service, for use in Company’s marketing or business
                  development, or for its other business efforts, subject, in
                  all cases, to the provisions of our{" "}
                  <Link
                    to="/privacy"
                    className="text-decoration-undeline text-white"
                  >
                    Privacy Notice
                  </Link>{" "}
                  with respect to your personal information. Your Notable User
                  Data may be transferred in any sale of the Company or its
                  assets and you consent to such transfer. You agree to
                  irrevocably waive (and cause to be waived) and hereby do waive
                  any claims and assertions of “moral rights” or attribution
                  with respect to your Notable User Content. You represent that
                  you have the authorization to consent to Company’s use of any
                  of your Notable User Content (as specified below), as
                  applicable. Because you alone are responsible for your Notable
                  User Content, you may expose yourself to liability if, for
                  example, your Notable User Content violates any third-party
                  intellectual property rights, privacy rights, agreements,
                  applicable laws, rules, or regulations.
                </li>
              </ol>
            </p>

            <p>
              <span className="spanterms">10. DMCA/Copyright Policy</span>
              <p className="font-300-15">
                We respect copyright law and expect visitors and users to do the
                same. It is our policy to terminate in appropriate circumstances
                the Accounts of users who repeatedly infringe the rights of
                copyright holders.
              </p>
              <p className="font-300-15">
                The Digital Millennium Copyright Act of 1998 (the “
                <span className="spanterms">DMCA</span>”) provides recourse for
                copyright owners who believe that material appearing on the
                Internet infringes their rights under U.S. copyright law. If you
                believe in good faith that content on the Site infringes your
                copyright, you (or your agent) may send a notice to the DMCA
                Agent listed below requesting that such content be removed or
                access to it blocked. Federal law requires that your
                notification include the following information: (i) a physical
                or electronic signature of a person authorized to act on behalf
                of the owner of an exclusive right that is allegedly infringed;
                (ii) identification of the copyrighted work claimed to have been
                infringed or, if multiple copyrighted works at a single online
                site are covered by a single notification, a representative list
                of such works at that site; (iii) identification of the material
                that is claimed to be infringing or to be the subject of
                infringing activity and that is to be removed or access to which
                is to be disabled and information reasonably sufficient to
                permit us to locate the material; (iv) information reasonably
                sufficient to permit us to contact you, such as an address,
                telephone number, and, if available, an electronic mail; (v) a
                statement that you have a good faith belief that use of the
                material in the manner complained of is not authorized by the
                copyright owner, its agent, or the law; and (vi) a statement
                that the information in the notification is accurate, and under
                penalty of perjury, that you are authorized to act on behalf of
                the owner of an exclusive right that is allegedly infringed.
              </p>
              <p className="font-300-15">
                FAN1 LLC
                <br />
                c/o DMCA Agent
                <br />
                19125 North Creek Parkway
                <br />
                Ste 120 PMB 675
                <br />
                Bothell, WA 98011-8000
                <br />
                copyright@fan1.us
              </p>
              <p className="font-300-15">
                We provide the above contact information for the purposes of the
                DMCA only and reserve the right to respond only to
                correspondence that is relevant to this purpose.
              </p>
            </p>

            <p>
              <span className="spanterms">
                11. Representations and Warranties
              </span>
              <p className="font-300-15">
                <span className="spanterms">
                  11.1 Notable User Representations and Warranties
                </span>
                . As a Notable User, you represent and warrant to Company and
                its users that:
              </p>
              <ol>
                <li className="font-300-15 mt-2">
                  You will fulfill and comply with all of the requirements and
                  benefits outlined in the Marketplace in relation to your
                  singular and exclusive Fan1 membership for the duration of the
                  membership period.
                </li>
                <li className="font-300-15 mt-2">
                  Your participation in the Marketplace, use of the Service, and
                  consent to this Agreement does not violate any agreement that
                  you may have with any third-party (e.g. sponsors, agents,
                  etc.).
                </li>
                <li className="font-300-15 mt-2">
                  You will not contact, respond to, or communicate with any user
                  that you meet through our Site, except as expressly permitted
                  by through our Site.
                </li>
                <li className="font-300-15 mt-2">
                  You own all rights in and to your Notable User Content and
                  Feeback and that you have the right to grant the rights
                  described in this Agreement.
                </li>
                <li className="font-300-15 mt-2">
                  Your Notable User Content and Feedback does not infringe,
                  misappropriate, or otherwise use without necessary
                  authorization, any intellectual property, privacy, publicity,
                  moral, or other rights of any third party, or violate any law.
                </li>
                <li className="font-300-15 mt-2">
                  You will comply with all applicable terms of any third-party
                  payment provider we select, and you are not on a prohibited
                  list of that third-party payment provider.
                </li>
                <li className="font-300-15 mt-2">
                  You have not been prohibited from using or accessing any
                  aspect of our Site by us or pursuant to any applicable law or
                  regulation.
                </li>
              </ol>
            </p>

            <p>
              <span className="spanterms">12. Disclaimer of Warranties</span>
              <p className="font-300-15 ps-2">
                The Service is provided “as-is” and “as available.” We expressly
                disclaim any warranties and conditions of any kind, whether
                express or implied, including the warranties or conditions of
                merchantability, fitness for a particular purpose, title, quiet
                enjoyment, accuracy, or non-infringement. Company makes no
                warranty that the Service: (a) will meet your requirements; or
                (b) will be available on an uninterrupted, timely, secure, or
                error-free basis.
              </p>
              <p className="font-300-15 ps-2">
                Additionally, while we will work to uphold our Code of Conduct
                and maintain a healthy and safe environment for our community of
                Fan1 users, we cannot guarantee and disclaim any liability or
                responsibility for any interaction with or content that you
                encounter posted by any other user of the Service. This may
                include offensive, illegal, harassing, explicit, or malicious
                content, behavior, or links to outside material.
              </p>
              <p className="font-300-15 ps-2">
                Some jurisdictions do not allow the exclusion of implied
                warranties, so the above exclusion may not apply to you.
              </p>
            </p>

            <p>
              <span className="spanterms">13. Limitation of Liability</span>
              <p className="font-300-15">
                EXCEPT TO THE EXTENT THAT SUCH EXCLUSION OR LIMITATION IS
                PROHIBITED UNDER APPLICABLE LAW, COMPANY WILL NOT BE LIABLE FOR
                ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY, OR
                PUNITIVE DAMAGES OF ANY KIND, UNDER ANY CONTRACT, TORT
                (INCLUDING NEGLIGENCE), STRICT LIABILITY, OR OTHER THEORY,
                INCLUDING DAMAGES FOR LOSS OF PROFITS, USE, OR DATA, LOSS OF
                OTHER INTANGIBLES, LOSS OF SECURITY OF SUBMISSIONS (INCLUDING
                UNAUTHORIZED INTERCEPTION BY THIRD PARTIES OF ANY SUBMISSIONS),
                EVEN IF ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH DAMAGES OR
                LOSSES. WITHOUT LIMITING THE FOREGOING, COMPANY WILL NOT BE
                LIABLE FOR DAMAGES OF ANY KIND RESULTING FROM YOUR USE OF OR
                INABILITY TO USE THE SERVICE OR FROM ANY PRODUCTS OR THIRD-PARTY
                MATERIALS.
              </p>
              <p className="font-300-15">
                THE MAXIMUM AGGREGATE LIABILITY OF COMPANY FOR ALL DAMAGES,
                LOSSES AND CAUSES OF ACTION ARISING OUT OF OR IN CONNECTION WITH
                THIS AGREEMENT, WHETHER IN CONTRACT, TORT (INCLUDING
                NEGLIGENCE), OR OTHERWISE, WILL BE THE GREATER OF (A) THE TOTAL
                AMOUNT, IF ANY, PAID BY YOU TO COMPANY IN CONNECTION WITH THIS
                AGREEMENT, AND (B) ONE HUNDRED U.S. DOLLARS ($100). ALL
                LIMITATIONS OF LIABILITY OF ANY KIND (INCLUDING IN THIS SECTION
                AND ELSEWHERE IN THIS AGREEMENT) ARE MADE ON BEHALF OF BOTH
                COMPANY AND THE AFFILIATED ENTITIES.
              </p>
              <p className="font-300-15">
                Applicable law may not allow for limitations on certain implied
                warranties, or exclusions or limitations of certain damages;
                solely to the extent that such law applies to you, some or all
                of the above disclaimers, exclusions, or limitations may not
                apply to you, and you may have certain additional rights.
              </p>
            </p>

            <p>
              <span className="spanterms">14. Indemnity</span>
              <p className="font-300-15">
                Except to the extent prohibited under applicable law, you agree
                to defend, indemnify, and hold harmless Company (and its
                officers, directors, employees, and agents) from and against all
                claims, losses, costs, and expenses (including reasonable
                attorneys’ fees) arising out of (a) your use of, or activities
                in connection with, the Service (including all Submissions and
                Feedback) in violation or attempted violation of this Agreement;
                (b) your violation of any third-party right, including any
                intellectual property or privacy right or your agreements with
                any third parties with respect to your engagement with the Site
                and receipt of any compensation through the sale of a Fan1
                membership, or claim of a third party that you did not have the
                rights to act as the Administrator of the Other Figure; (c) any
                of your submissions or Feedback; (d) your violation of any
                applicable law, rule, or regulation; or (e) any misuse of your
                unique username, password, or other appropriate access
                credential for which you are responsible. Company reserves the
                right, at your expense, to assume the exclusive defense and
                control of any matter for which you are required to indemnify
                the Company (or its officers, directors, employees, and agents)
                and you agree to cooperate with Company’s defense of these
                claims. You agree not to settle any matter without the prior
                written consent of Company. The Company will use reasonable
                efforts to notify you of any such claim, action or proceeding
                upon becoming aware of it.
              </p>
            </p>

            <p>
              <span className="spanterms">15. Contractor Status</span>
              <p className="font-300-15">
                The Company is an independent contractor and service provider to
                you, and neither party is an agent or partner of the other. Your
                account will include a statement of all Fan1 Payouts and
                compensation paid to you by Company. You are responsible for
                reporting as income all Fan1 Payouts and compensation you
                receive from the Company under this Agreement and for paying all
                self-employment or other taxes, including any local and foreign
                taxes, duties, tariffs, levies, withholdings and similar
                assessments (including without limitation, sales taxes, use
                taxes and value added taxes). You agree to indemnify and hold
                Company harmless to the extent that any obligation is imposed on
                Company to pay withholding taxes, local and foreign taxes,
                duties, tariffs, levies, and similar assessments (including
                without limitation, sales taxes, use taxes and value added
                taxes) resulting from the compensation paid to you under this
                Agreement or a determination that you are an employee of Company
                under any applicable law.
              </p>
            </p>

            <p>
              <span className="spanterms">16. Suspension and Termination</span>
              <p className="font-300-15">
                This Agreement is effective until your right to use the Service
                is suspended or terminated, or you terminate your account and
                cease using the Service. We may suspend or terminate your right
                to use the Service at any time for any reason. Upon any such
                suspension or termination, your right to use the Service will
                immediately cease, and we may, without liability to you or any
                third party, immediately deactivate or delete your username,
                password, and account, and all associated materials, including
                your Notable User Content, without any obligation to provide any
                further access to such materials. Following any deactivation of
                your account, we reserve the right to retain and display any
                prior messages or other content you submitted to or through the
                Site associated with you as a Notable User. We have no
                obligation to store or back-up any information or Notable User
                Content on your account or that you submitted through the
                Service.
              </p>
            </p>

            <p>
              <span className="spanterms">17. Jurisdictional Issues</span>
              <p className="font-300-15">
                The Service is controlled or operated (or both) from the United
                States and is not intended to subject Company to any
                jurisdiction or law except as provided in Section 18 below. The
                Service may not be appropriate or available for use in some
                non-U.S. jurisdictions. You must comply with all applicable
                laws, rules, and regulations in connection with your use of the
                Service. We may limit the Service’s availability at any time, in
                whole or in part, to any person, geographic area or
                jurisdiction, in each case in our reasonable discretion.
              </p>
            </p>
            <p>
              <span className="spanterms">
                18. DISPUTE RESOLUTION. PLEASE READ THIS CAREFULLY. IT AFFECTS
                YOUR RIGHTS
              </span>
              <ol>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">Mandatory Arbitration</span>. Any
                  and all controversies, disputes, demands, counts, claims, or
                  causes of action (including the interpretation and scope of
                  this clause, and the arbitrability of the controversy,
                  dispute, demand, count, claim, or cause of action) between you
                  and Company and/or Company’s employees, agents, successors, or
                  assigns, regarding or relating to the Service or this
                  Agreement, will exclusively be settled through binding and
                  confidential arbitration.
                </li>
                <li className="font-300-15 mt-2">
                  <span className="spanterms">Rules of Arbitration</span>.
                  Arbitration will be subject to the Federal Arbitration Act and
                  not any state arbitration law. The arbitration will be
                  conducted before one commercial arbitrator with substantial
                  experience in resolving commercial contract disputes from the
                  American Arbitration Association (“AAA”) or JAMS, as mutually
                  determined by the parties (if the parties are unable to
                  mutually agree on AAA or JAMS, Company will have sole
                  authority to choose either AAA or JAMS. As modified by this
                  Agreement, and unless otherwise agreed upon by the parties in
                  writing, the arbitration will be governed by the AAA’s or
                  JAMS’s rules for commercial arbitration or, if the arbitrator
                  deems them applicable, the procedures for consumer-related
                  disputes.
                </li>
              </ol>
              <p className="font-300-15">
                For more information on AAA, its Rules and Procedures, and how
                to file an arbitration claim, you may visit the AAA website at:
                http://www.adr.org. For more information on JAMS, it’s rules and
                procedures, and how to file an arbitration claim, you may visit
                the JAMS website at: http://www.jamsadr.com.
              </p>
              <p className="font-300-15">
                You are giving up your right to go to court to assert or defend
                your rights, except for matters that may be taken to small
                claims court. Your rights will be determined by a neutral
                arbitrator and not a judge or jury. You are entitled to a fair
                hearing, but the arbitration procedures are simpler and more
                limited than rules applicable in court. Arbitrator decisions are
                as enforceable as any court order and are subject to very
                limited review by a court.
              </p>
              <p className="font-300-15">
                The parties must abide by the following rules: (1) any claims
                brought by either party must be brought in the parties’
                individual capacity, and not as a plaintiff or class member in
                any purported class or representative proceeding; (2) the
                arbitrator may not consolidate more than one person’s claims,
                may not otherwise preside over any form of a representative or
                class proceeding, and may not award class-wide relief; (3) in
                the event that you are able to demonstrate that the costs of
                arbitration will be prohibitive as compared to costs of
                litigation, Company will pay as much of your filing and hearing
                fees in connection with the arbitration as the arbitrator deems
                necessary to prevent the arbitration from being cost-prohibitive
                as compared to the cost of litigation; (4) Company also reserves
                the right in Company’s sole and exclusive discretion to assume
                responsibility for all of the costs of the arbitration; (5) the
                arbitrator will honor claims of privilege and privacy recognized
                at law; (6) the arbitrator’s award will be final and may be
                enforced in any court of competent jurisdiction; (7) the
                arbitrator may award any individual relief or individual
                remedies that are permitted by applicable law; and (8) each side
                pays its own attorneys’ fees and expenses unless there is a
                statutory provision that requires the prevailing party to be
                paid its fees’ and litigation expenses, and then in such
                instance, the fees and costs awarded will be determined by the
                applicable law.
              </p>
              <p className="font-300-15">
                <span className="spanterms">18.1 Exception</span>.
                Notwithstanding the foregoing, either of the parties may bring
                an individual action in small claims court. Further, claims of
                infringement or misappropriation of the other party’s patent,
                copyright, trademark, or trade secret will not be subject to
                this arbitration agreement. Such claims will be exclusively
                brought in the state or federal courts located in King County,
                Washington. Additionally, notwithstanding this agreement to
                arbitrate, either party may seek emergency equitable relief
                before the state or federal courts located in King County,
                Washington in order to maintain the status quo pending
                arbitration, and hereby agree to submit to the exclusive
                personal jurisdiction of the courts located within King County,
                Washington for such purposes. A request for interim measures
                will not be deemed a waiver of the right to arbitrate.
              </p>
              <p className="font-300-15">
                <span className="spanterms">18.2 Severability</span>. With the
                exception of subparts (1) and (2) in the paragraph 18.2 above
                (prohibiting arbitration on a class or collective basis), if any
                part of this arbitration provision is deemed to be invalid,
                unenforceable or illegal, or otherwise conflicts with the
                Agreement, then the balance of this arbitration provision will
                remain in effect and will be construed in accordance with its
                terms as if the invalid, unenforceable, illegal or conflicting
                provision were not contained herein. If, however, either
                subparts (1) and (2) in the paragraph 18.2 (prohibiting
                arbitration on a class or collective basis) is found to be
                invalid, unenforceable or illegal, then the entirety of this
                arbitration provision will be null and void, and neither of the
                parties will be entitled to arbitration. If for any reason a
                claim proceeds in court rather than in arbitration, the dispute
                will be exclusively brought in state or federal court in King
                County, Washington.
              </p>
              <p className="font-300-15">
                <span className="spanterms">18.3 Termination</span>.
                Notwithstanding any provision in this Agreement to the contrary,
                if Company seeks to terminate the Dispute Resolution section as
                included in the Agreement, any such termination will not be
                effective until 30 days after the version of the Agreement not
                containing the agreement to arbitrate is posted to the Site, and
                will not be effective as to any claim of which you provided
                Company with written notice prior to the date of termination.
              </p>
              <p className="font-300-15">
                <span className="spanterms">18.4 Governing Law</span>. Any and
                all controversies, disputes, demands, counts, claims, or causes
                of action between you and Company’s employees, agents,
                successors, or assigns, regarding or relating to the Service or
                this Agreement, will be exclusively governed by the internal
                laws of the State of Washington, without regard to its choice of
                law rules and without regard to conflicts of laws principles,
                except that the arbitration provision will be governed by the
                Federal Arbitration Act.
              </p>
              <p className="font-300-15">
                <span className="spanterms">18.5 Opt-Out</span>. You have the
                right to opt-out of the mandatory arbitration provisions of this
                Section 18. You may do so by sending notice to our contact
                address listed in this Agreement within 30 days of first
                accepting this Agreement on creation of your Account. Your
                notice must provide us with your full name, email address, and
                your username, along with your decision to opt-out under this
                Section 18.7. To the extent you choose to opt out, any action
                arising out of or in connection with this Agreement and/or your
                use of the Service will be heard in the federal, state, or local
                courts in King County, Washington, and each party hereby
                irrevocably consents to the exclusive jurisdiction and venue of
                these courts. The parties waive any right to demand a trial by
                jury.
              </p>
            </p>

            <p>
              <p className="font-300-15">
                <span className="spanterms">19.1 Entire Agreement</span>. This
                Agreement constitutes the entire agreement between you and
                Company regarding the use of the Service. The Company’s failure
                to exercise or enforce any right or provision of this Agreement
                will not operate as a waiver of such right or provision. The
                section titles in this Agreement are for convenience only and
                have no legal or contractual effect. The word “including” means
                “including without limitation.” If any provision of this
                Agreement is, for any reason, held to be invalid or
                unenforceable, the other provisions of this Agreement will be
                unimpaired, and the invalid or unenforceable provision will be
                deemed modified so that it is valid and enforceable to the
                maximum extent permitted by law. 
              </p>
              <p className="font-300-15">
                <span className="spanterms">19.2 Assignment</span>. This
                Agreement, and your rights and obligations herein, may not be
                assigned, subcontracted, delegated, or otherwise transferred by
                you without the Company’s prior written consent, and any
                attempted assignment, subcontract, delegation, or transfer in
                violation of the foregoing will be null and void. The terms of
                this Agreement will be binding upon assignees. Notwithstanding
                the foregoing, The Company may assign this Agreement without the
                other party’s prior written consent as part of a merger,
                re-domestication, or a sale or transfer of all or substantially
                all of its assets, or any business division covering
                substantially all the Service. This Agreement will be binding
                upon, enforceable by, and inure to the benefit of the parties
                and their respective and permitted assignees.
              </p>
              <p className="font-300-15">
                <span className="spanterms">19.3 Electronic Communications</span>.
                Notices to you (including
                notices of changes to this Agreement) may be made via posting to
                the Site or by email (including in each case via links), or by
                regular mail. You (a) consent to receive all communications
                electronically and (b) agree that all terms and conditions,
                agreements, notices, disclosures, and other communications that
                we provided to you electronically satisfies any legal
                requirement that such communications would satisfy if it were in
                a hardcopy writing.
              </p>
              <p className="font-300-15">
                <span className="spanterms">19.4 Contact Information</span>.
                Notices to Company may be sent to:{" "}
                <a
                  href="mailto:notices@fan1.us."
                  className="White text-decoration-none"
                >
                  notices@fan1.us.
                </a>
              </p>
            </p>

            <p className="font-300-15 mt-5">Last Modified: May 15, 2025</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotableUserTerms;
